import React from 'react';
import PropTypes from 'prop-types';

import { QualificationCodes } from 'constants.js';
import { GroupeTraitementCodes } from 'constants.js';

import { connect } from 'react-redux';
import { addAction } from 'store/reclamation/reclamationsActions';
import { cloturer } from 'store/reclamation/reclamationsActions';
import { fetchGroupes } from 'store/groupe/groupeActions';

import { fetchReclamationQualificationsIfNeeded } from 'store/reclamation/detailsActions';
import { fetchAffectation } from 'store/reclamation/reclamationsActions';


import QualificationCodeColisRefuseForm from './QualificationCodeColisRefuseForm';
import QualificationCodeAdresseErroneeInconnueForm from './QualificationCodeAdresseErroneeInconnueForm';
import QualificationCodeContactTelephoneManquantForm from './QualificationCodeContactTelephoneManquantForm';
import QualificationCodeAbsentAviseNeRepondPasForm from './QualificationCodeAbsentAviseNeRepondPasForm';
import QualificationCodeColisImpresentableForm from './QualificationCodeColisImpresentableForm';
import QualificationCodeRefusDeLivraisonPartielForm from './QualificationCodeRefusDeLivraisonPartielForm';



const children = [
    {
        code: QualificationCodes.ColisRefuse,
        composant: QualificationCodeColisRefuseForm
    },
    {
        code: QualificationCodes.AdresseErroneeInconnue,
        composant: QualificationCodeAdresseErroneeInconnueForm
    },
    {
        code: QualificationCodes.ContactTelephoneManquant,
        composant: QualificationCodeContactTelephoneManquantForm
    },
    {
        code: QualificationCodes.AbsentAviseNeRepondPas,
        composant: QualificationCodeAbsentAviseNeRepondPasForm
    },
    {
        code: QualificationCodes.ColisImpresentable,
        composant: QualificationCodeColisImpresentableForm
    },
    {
        code: QualificationCodes.RefusDeLivraisonPartiel,
        composant: QualificationCodeRefusDeLivraisonPartielForm
    }
];


class AddReponseToSouffranceTransporteurMemoContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchAffectation(this.props.reclamationId);
        await this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
        await this.props.fetchGroupes();
    }
    

    render() {
        const { isLoading, qualifications, reclamationId, action, actionId, isAdding, addAction, cloturer, groupeTransportId } = this.props;

        if (!qualifications) {
            return null;
        }

        let child = children.find(x => x.code === this.props.qualifications.qualification.code);

        if (!child) {
            return null;
        }
                       
        let Content = child.composant;

        if (!Content) {
            return null;
        }
        
        return (

            <Content
                isLoading={isLoading}
                reclamationId={reclamationId}
                actionId={actionId}
                
                onClickSave={this.handleClickSave}
                onClickCancel={this.handleClickCancel}
                onChange={this.handleChange}

                action={action}
                isAdding={isAdding}

                addAction={addAction}
                cloturer={cloturer}
                groupeTransportId={groupeTransportId}
                
            />

        );
    }
}

AddReponseToSouffranceTransporteurMemoContainer.propTypes = {
    actionId: PropTypes.number.isRequired,
    reclamationId: PropTypes.number.isRequired
};




const mapStateToProps = (state, ownProps) => {

    let groupeTransportId = 0;
    let groupes = state.groupe.groupes.items;


    if (groupes) {
        let groupeTransport = groupes.find(x => x.code === GroupeTraitementCodes.ServiceTransport);
        if (groupeTransport !== undefined) {
            groupeTransportId = groupeTransport.id;
        }
    }

    return {
        isAdding: state.common.addActionData.actionId === ownProps.actionId,

        isLoading: state.reclamation.details.isQualificationsLoading || state.groupe.groupes.isLoading,

        qualifications: state.reclamation.details.qualifications,

        groupeTransportId: groupeTransportId
    };
};


const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId, affectationGroupeId) => dispatch(addAction(reclamationId, actionData, actionId, affectationGroupeId)),
    cloturer: (reclamationId, cloture) => dispatch(cloturer(reclamationId, cloture)),
    fetchReclamationQualificationsIfNeeded: id => dispatch(fetchReclamationQualificationsIfNeeded(id)),
    fetchAffectation: (reclamationId) => dispatch(fetchAffectation(reclamationId)),
    fetchGroupes: () => dispatch(fetchGroupes())

});

export default connect(mapStateToProps, mapDispatchToProps)(AddReponseToSouffranceTransporteurMemoContainer);